import type { ITreatmentPlanGoalTarget } from '../../../../../../utils/types';

export const getV1TargetDuplicationData = (target: ITreatmentPlanGoalTarget) => {
  return {
    instruction: target.instruction ?? '',
    expanded: true,
    is_event_duration_required: false,
    is_active: true,
    is_editing: true,
    dirty: true,
  };
};
